import {
    CREATE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK,
    CREATE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK,
    CREATE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK,
    DELETE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK,
    DELETE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK,
    DELETE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK,
    FETCH_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK,
    FETCH_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK,
    UPDATE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK,
    UPDATE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK,
    UPDATE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK,
    RESET_IRONING_PACKING_INWARD_DETAILS_INFO_DK,
    CREATE_IRONING_PACKING_INWARD_DETAILS_FORM_DK,
    UPDATE_IRONING_PACKING_INWARD_DETAILS_FORM_DK,
    FETCH_IRONING_PACKING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK
} from './ironingPackingInwardDetails.actionsType';

export const IRONING_PACKING_INWARD_DK_DETAILS = 'ironingPackingInwardDKDetails';

let initialState = {
    loading: false,
    ironingPackingInwardDetails: [],
    ironingPackingInwardDetailsWithoutId: [],
    previousGetList: [],
    ironingPackingInwardDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        // fldReceivingRolls: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let ironingPackingInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK:
        case CREATE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK:
        case DELETE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardDetails: updatePayload
            };
        case FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.IPI
            };
        case FETCH_IRONING_PACKING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardDetailsWithoutId: updatePayload
            };
        case CREATE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case UPDATE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardDetailsForm: updatePayload
            };
        case DELETE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case RESET_IRONING_PACKING_INWARD_DETAILS_INFO_DK:
            return {
                ...state,
                ironingPackingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case CREATE_IRONING_PACKING_INWARD_DETAILS_FORM_DK:
        case UPDATE_IRONING_PACKING_INWARD_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardDetailsForm: {
                    ...state.ironingPackingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK:
        case CREATE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK:
        case DELETE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
